var basketCount = document.querySelector('.wdm-quoteupicon-count');
var addToCartBtns = document.querySelectorAll('.btn--add-to-cart__sm, a[name="add-to-cart"]');
var basketCountDisplay = document.querySelector('#basket-count');
var removeBtns = document.querySelectorAll('.remove');
var bubble = document.querySelector('#wdm-cart-count');
var linkToHide = document.querySelector('#product-details-and-actions');
var modalPopup = document.querySelector('#hire-button-modal');
var textArea = document.querySelectorAll('.form-control')[4];
var bname = document.querySelectorAll('.form-control')[0];
var email = document.querySelectorAll('.form-control')[3];
var br = document.querySelectorAll('br');
var loadingOverlay = document.querySelector('.loading-overlay');
var formTitle = document.querySelector('.wdm-enquiry-form-title');
var headerQuantity = document.querySelector('.cart-quantity');

headerQuantity ? (headerQuantity.innerText = 'QTY') : null;
formTitle ? (formTitle.innerText = 'Your Details') : null;

br.forEach(br => br.remove());

var messageLabel = `<label for="field" style="display: block;clear: both">Additional Message</label>`;
var nameLabel = `<label for="field" style="display: block;clear: both">Name</label>`;
var emailLabel = `<label for="field" style="display: block;clear: both">Email</label>`;

textArea ? textArea.insertAdjacentHTML('beforebegin', messageLabel) : null;
bname ? bname.insertAdjacentHTML('beforebegin', nameLabel) : null;
email ? email.insertAdjacentHTML('beforebegin', emailLabel) : null;

linkToHide ? linkToHide.children[0].classList.add('hidden') : null;
bubble ? bubble.classList.add('hidden') : null;
addToCartBtns.forEach(btn => {
    btn.addEventListener('click', e => {
        loadingOverlay.classList.remove('hidden');

        setTimeout(() => {
            basketCountDisplay.innerText = document.querySelector(
                '.wdm-quoteupicon-count'
            ).innerText;
            loadingOverlay.classList.add('hidden');

            //Show modal
            jQuery('#hire-button-modal').foundation('open');
        }, 1200);
    });
});

removeBtns.forEach(btn =>
    btn.addEventListener('click', () => {
        basketCount.innerText = '';
        loadingOverlay.classList.remove('hidden');

        setTimeout(() => {
            loadingOverlay.classList.add('hidden');
            basketCountDisplay.innerText = basketCount.innerText;
            location.reload();
        }, 750);
    })
);




setInterval(function() {


    if (isNaN(basketCountDisplay.innerText)) {


        console.log(" This is not a number");

        location.reload();

        //      basketCountDisplay.innerText = "0"
    }

    basketCountDisplay.innerText = document.querySelector('.wdm-quoteupicon-count').innerText
}, 1000);






//let oldvalue = document.querySelector('.wdm-cart-count').innerHTML;


//function check1(oldvalue) {
//  undefined === oldvalue && (oldvalue = value);
// clearcheck = setInterval(repeatcheck, 500, oldvalue);

//    function repeatcheck(oldvalue) {
//      if (value !== oldvalue) {

//        clearInterval(clearcheck);
//      console.log("check1 value changed from " +
//    oldvalue + " to " + value);



// basketCountDisplay.innerText = basketCount.innerText;

// document.querySelector('#basket-count').

// }
// }
// }